<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
      <div class="col-12">
        <navbar isBtn="bg-gradient-light" />
      </div>
    </div>
  </div>
  <main class="main-content mt-0">
    <div
      class="page-header align-items-start min-vh-50 pt-5 pb-11 m-3 border-radius-lg"
      style="background-image: url('https://raw.githubusercontent.com/creativetimofficial/public-assets/master/argon-dashboard-pro/assets/img/signup-cover.jpg'); background-position: top;"
    >
      <span class="mask bg-gradient-dark opacity-6"></span>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-5 text-center mx-auto">
            <h1 class="text-white mb-2 mt-5">Welcome To Jarvis !</h1>
            <!-- <p
              class="text-lead text-white"
            >Use these awesome forms to login or create new account in your project for free.</p> -->
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row mt-lg-n10 mt-md-n11 mt-n10 justify-content-center">
        <div class="col-xl-4 col-lg-5 col-md-7 mx-auto">
          <div class="card z-index-0">
             <div class="card-header text-center pt-4">
              <h5><span class="text-white bg-dark fs-5 p-2 rounded">Jarvis</span> Register</h5>
            </div>
            <div class="card-body">
              <form role="form" @submit.prevent="SignUp">
                <input  class="input-group-text form-control my-3 fs-6" type="text" placeholder="Name" v-model="name"  />
                <input  class="input-group-text form-control my-3 fs-6" type="email" placeholder="Email" v-model="email"  />
                <input  class="input-group-text form-control my-3 fs-6" type="password" placeholder="Password" v-model="password" />
                <!-- <argon-checkbox checked>
                  <label class="form-check-label" for="flexCheckDefault">
                    I agree the
                    <a
                      href="javascript:;"
                      class="text-dark font-weight-bolder"
                    >Terms and Conditions</a>
                  </label>
                </argon-checkbox> -->
                <div class="text-center">
                  <argon-button fullWidth color="dark" variant="gradient" class="my-4 mb-2">Sign up</argon-button>
                </div>
                <p class="text-sm mt-3 mb-0">
                  Already have an account?
                  <button @click="signin"
                    class="text-dark font-weight-bolder border-0 bg-transparent"
                  >Sign in</button>
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
  <!-- <app-footer /> -->
</template>

<script>
import Navbar from "@/examples/PageLayout/Navbar.vue";
// import AppFooter from "@/examples/PageLayout/Footer.vue";
// import ArgonInput from "@/components/ArgonInput.vue";
// import ArgonCheckbox from "@/components/ArgonCheckbox.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import router from "../router";
const body = document.getElementsByTagName("body")[0];

export default {
  name: "signup",
  components: {
    Navbar,
    // AppFooter,
    // ArgonInput,
    // ArgonCheckbox,
    ArgonButton,
  },
  data(){
    return{
      name : null,
      email : null,
      password: null 

    }
  },
  methods:{
    signin(){
    router.push('/signin')
    },
    SignUp(){
      router.push('/dashboard')
      this.axios.post('').then(($resp) => {
        console.log($resp)
      }).catch(($err)=>{
          console.log($err)
      });
  }
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
};
</script>
